import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import ScreeningService from '../../common/ScreeningService'

export const getScreeningPrice = createAsyncThunk(
  'tool/screening/getScreeningPrice',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getScreeningPrice(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportFile = createAsyncThunk(
  'tool/screening/exportFile',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.exportFile(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)

export const getVoucher = createAsyncThunk(
  'tool/screening/getVoucher',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ScreeningService.getVoucher(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false, message: err })
    }
  },
)
